import { Button, } from "@bracket/ui";

interface SaveFormBtnProps {
  loading?: boolean;
  disabled?: boolean;
}

export const SaveFormBtn: React.FC<SaveFormBtnProps> = ({
  loading,
  disabled,
}) => {
  return (
    <Button
      label="Save changes"
      variant="primary"
      size="md"
      busy={loading}
      disabled={disabled}
      type="submit"
    />
  );
};
